export default __webpack_public_path__ + "static/media/televisions.2af9906e.png";